import { WatermarkPosition } from '@/api/entities/group';
import { z } from 'zod';

export const groupCustomImageSchema = z.object({
  id: z.string().optional(),
  blurVideoCheckPointLicensePlate: z.boolean().default(false),
  blurPhotoCheckPointLicensePlate: z.boolean().default(false),
  videoCheckPointLicensePlateImage: z.string().nullish(),
  photoCheckPointLicensePlateImage: z.string().nullish(),
  videoCheckPointBackground: z.string().nullish(),
  photoCheckPointBackground: z.string().nullish(),
  videoCheckPointWatermark: z.string().nullish(),
  photoCheckPointWatermark: z.string().nullish(),
  videoCheckPointWatermarkPosition: z.nativeEnum(WatermarkPosition).nullish(),
  photoCheckPointWatermarkPosition: z.nativeEnum(WatermarkPosition).nullish(),
});

export type TGroupCustomImageSchema = z.infer<typeof groupCustomImageSchema>;
